import {useRef, useEffect, useState} from 'react';
import axios from 'axios';

import CommandsPanel from './commandsPanel/commandsPanel';
import OutputBox from './outputComponent/outputComp';
import LogsBox from './logsComp/logsComp';
import SensorLogsBox from './sensorLogsComp/sensorLogsComp';
import IotCommandsPanel from './iotCommandPanel/iotCommandPanel';

// import './controlPanelPageStyle.css';
import StatusPanel from './statusPanelComponent/statusPanelComponent';
import iotPaths from '../../assets/iotPaths.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight, faCamera } from '@fortawesome/free-solid-svg-icons';

function ControlPanel(props) {
    const [deviceData, setDeviceData] = useState(null);
    const [url, setUrl] = useState(null);
    const [img, setImg] = useState(null);
    const [cameraInterval, setCameraInterval] = useState(["none"]);
    const [intervalId, setIntervalId] = useState(null);

    const handleChange = (event) => {
        clearInterval(intervalId);
        const options = event.target.options;
        const values = Array.from(options)
          .filter((option) => option.selected)
          .map((option) => option.value);
        setCameraInterval(values);

        handleInterval(values);
    };

    const createOutputMsg = (msg) => {
        // Grab current time and create timestamp
        const now = new Date(Date.now());
        const hours = now.getHours().toString().padStart(2, '0');
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const seconds = now.getSeconds().toString().padStart(2, '0');
        const timestamp = `${hours}:${minutes}:${seconds}`;

        const message = document.createElement('li');
        message.classList = "output-item";
        message.innerText =`${msg} | ${timestamp}`;
        document.getElementById('outputbox').append(message);
        document.getElementById('outputbox').scrollTop = document.getElementById('outputbox').scrollHeight;
    }

    const handleInterval = (values) => {
        if(values[0] === "1min") {
            // console.log("Set interval to " + values[0]);
            createOutputMsg(`Set time interval to ${values[0]}`);

            setIntervalId(setInterval(() => {
                // alert(values[0]);
                getPicture();
            }, 60000));
        } else if(values[0] === "30sec") {
            createOutputMsg(`Set time interval to ${values[0]}`);

            setIntervalId(setInterval(() => {
                // alert(values[0]);
                getPicture();
            }, 30000));
        } else if(values[0] === "10sec") {
            createOutputMsg(`Set time interval to ${values[0]}`);

            setIntervalId(setInterval(() => {
                // alert(values[0]);
                getPicture();
            }, 10000));
        } else {
            // console.log("clearing interval");
            createOutputMsg(`Cleared time interval`);

            clearInterval(intervalId);
        }
    }

    const getPicture = async () => {
        try {
            // Request object for API call
            const requestObject = {
                url: `${url}${iotPaths["camera"].path}`,
                method: iotPaths["camera"].method,
                headers: {"apiKey": deviceData.apiKey},
                data: {"format": "base64"}
            }

            // Append spinning loader
            // document.querySelector(".img-container").innerHTML = "";
            // document.querySelector(".img-container").innerHTML += `<div class="lds-ring" id="lds-ring"><div></div><div></div><div></div><div></div></div>`;

            // API call
            const apiResponse = await axios(requestObject);
            if(apiResponse.status === 200 || apiResponse.status === 201) {
                createOutputMsg(`Picture Successfully fetched`);
                
                // const base64 = btoa([].reduce.call(new Uint8Array(apiResponse.data.base64),function(p,c){return p+String.fromCharCode(c)},'')) Old way of converting image data into base64
                document.getElementById("img-container").innerHTML = `<img src='' id='cameraImg' />`;
                document.getElementById("cameraImg").src = 'data:image/png;base64,' + apiResponse.data.base64;
                // document.getElementById("lds-ring").parentNode.removeChild(document.getElementById("lds-ring")); // removes the lds spinning rings
            } else {
                createOutputMsg(apiResponse.data.message);
            }

        } catch (err) {
            console.error(err);
            createOutputMsg(`Error with fetching picture from device.`);
            alert(`Camera API call failed | ${err.message}`);
        }
    }

    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }

        const grabDevice = async () => {
            const loginToken = getCookie('data');
            const deviceId = window.location.pathname.split("/")[3];

            // Fetches the single devices data
            try {
                const fetchDevice = await axios({
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/devicedata/fetchone`,
                    method: "POST",
                    data: {
                        loginToken: loginToken,
                        deviceId: deviceId
                    }
                });

                // If device data was successfully fetched set the Data and Url states
                if(fetchDevice.status === 200) {
                    setTimeout(() => {
                        setDeviceData(fetchDevice.data.device);
                        setUrl(`https://${fetchDevice.data.device.domainName}:${fetchDevice.data.device.port}`);
                        console.log("Grabbed device data from DB successfully");
                    }, 2000);
                } else {
                    setTimeout(() => {
                        console.log("Failed to grab device data from DB");
                        setData({hostname: "Something went wrong when connecting to your device"});
                    }, 5000);
                    location.href('/dashboard');
                }
            } catch (err) {
                console.log(err);
            }
        }
        grabDevice();
    },[]);
    
    return (
        <>
        <div className='spacer'></div>
        <div className='spacer'></div>
        <article className=''>
            {url ?
            <section className=''> 
                {deviceData.deviceType === "computer" ? 
                <section className=''>
                    <CommandsPanel props={{url, deviceData}} />
                    <OutputBox />
                    <LogsBox />
                </section>
                :
                <section className='flex-nogap row'>
                    <section className='flex column'>
                        <StatusPanel props={{url, deviceData}} />
                        <section className='camera-container flex-nogap column flex-nowrap min-height-400px max-height-1080px min-width-600px max-height-1920px border rounded'>
                            <div className='interval-select flex-nogap row flex-nowrap justify-content-space-between border-bottom padding-sm'>
                                <h2>Camera </h2>
                                <FontAwesomeIcon icon={faRotateRight} />
                                <div>
                                    <label htmlFor="repeat-camera">Repeat Every: </label>
                                    <select id="repeat-camera" value={cameraInterval} onChange={handleChange}>
                                        <option value="none" defaultValue={"none"}>None</option>
                                        <option value="1min">1 minute</option>
                                        <option value="30sec">30 seconds</option>
                                        <option value="10sec">10 seconds</option>
                                    </select>
                                    {/* <p>You selected: {cameraInterval.join(", ")}</p> */}
                                </div>
                            </div>
                            <div id='img-container' className='flex column justify-content-cntr align-items-cntr min-height-400px'>
                                <p className='img-message font-xs color-foreground' id='camera-message'>Select a <b>Repeat</b> option or click the <FontAwesomeIcon icon={faCamera} className='img-icon font-xs' /> button to grab a live picture</p>
                            </div>
                        </section>
                    </section>
                    <div className='flex column margin-l-sm'>
                        <IotCommandsPanel props={{url, deviceData}} />
                        <OutputBox />
                        <SensorLogsBox />
                        <LogsBox />
                    </div>
                </section>
                }
            </section>
            :
            <>
            <div className='spacer'></div>
            <div className='spacer'></div>
            <section className='flex column justify-content-cntr align-items-cntr bg-color-background'>
                <h1 className='h1'>Establishing Connection...</h1>
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
            </section>
            <div className='spacer'></div>
            <div className='spacer'></div>
            </>
            }
        </article>
        <div className='spacer'></div>
        </>
    );
}

export default ControlPanel;